import React from "react";

function Salade() {
  return (
    <div class="wrapper" id="menu">
      <div class="title">
        <h4 style={{ textAlign: "center" }}>
          <span>voici nos Salades N'hésitez pas appelez le 09 50 85 13 53</span>
          Salades{" "}
        </h4>
      </div>
      <div class="menu">
        <div class="single-menu">
          <img
            src="https://p6.storage.canalblog.com/61/89/1467142/115707326.jpg"
            alt=""
          />
          <div class="menu-content">
            <h4>
              {" "}
              Salade Composée <span>5€</span>
            </h4>
            <p>Salade mixte,tomates, mais</p>
          </div>
        </div>
        <div class="single-menu">
          <img
            src="https://media-cdn.tripadvisor.com/media/photo-s/0f/88/b8/18/notre-salade-chevre-chaud.jpg"
            alt=""
          />
          <div class="menu-content">
            <h4>
              Salade Chèvre <span>5€</span>
            </h4>
            <p>Salade mixte,tomates, mais,chèvre</p>
          </div>
        </div>
        <div class="single-menu">
          <img
            src="https://d1ralsognjng37.cloudfront.net/aae5d88c-22b2-464a-a4a3-7946276082e1"
            alt=""
          />
          <div class="menu-content">
            <h4>
              Salade Tenders<span>6€</span>
            </h4>
            <p>Salade mixte,tomates, mais,tenders</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Salade;
